import * as React from 'react';

import { IStyleProps, mergeStyles, Popup } from '@cian/components';

const style = require('./index.css');

export interface IModalProps {
  minHeigth: number;
  maxHeight?: number;
  minWidth: number;
  maxWidth?: number;
  width?: string;

  headerStyle?: IStyleProps;
  contentStyle?: IStyleProps;
  footerStyle?: IStyleProps;

  header?: React.ReactNode;
  footer?: React.ReactNode;
  closeBtn?: React.ReactNode;
}

export class Modal extends React.Component<IModalProps> {
  public containerElement: HTMLDivElement | null;
  public render() {
    return (
      <Popup
        containerStyle={
          mergeStyles(
            style['modalContainer'],
            {
              width: this.props.width,
              minHeight: this.props.minHeigth,
              minWidth: this.props.minWidth,
              maxHeight: this.props.maxHeight,
              maxWidth: this.props.maxWidth,
            },
            // tslint:disable-next-line:no-any
          ) as any
        }
      >
        {this.props.closeBtn}
        {this.props.header && (
          <div {...mergeStyles(style['modalContainer-header'], this.props.headerStyle)}>{this.props.header}</div>
        )}
        <div
          ref={r => (this.containerElement = r)}
          {...mergeStyles(style['modalContainer-content'], this.props.contentStyle)}
        >
          {this.props.children}
        </div>
        {this.props.footer && (
          <div {...mergeStyles(style['modalContainer-footer'], this.props.footerStyle)}>{this.props.footer}</div>
        )}
      </Popup>
    );
  }
}
